import emptyStateIconUrl from '@/assets/images/empty-state.svg';
import { cn } from '@/shared/utilities/cn';
import { Box, useTheme } from '@mui/material';
import type { FC } from 'react';

interface MessageEmptyProps {
  className?: string;
  mode?: 'compact' | 'comfortable';
}

export const MessageEmpty: FC<MessageEmptyProps> = ({ className, mode }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box
      component='section'
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      height='100%'
      sx={{
        gap: { xs: 2, sm: 3, md: 4 },
        px: { xs: 2, sm: 4, md: 6 },
        py: { xs: 4, sm: 6, md: 8 }
      }}
      color='text.secondary'
      className={cn('mex:min-h-[200px]', className)}
    >
      <Box
        sx={{
          width: mode === 'compact' ? 240 : { xs: 300, sm: 350, md: 600 },
          height: mode === 'compact' ? 180 : { xs: 180, sm: 210, md: 375 },
          opacity: 0.9
        }}
      >
        <img
          src={emptyStateIconUrl}
          alt='Empty state illustration'
          className='mex:h-full mex:w-full mex:object-contain'
          style={{
            filter: isDarkMode ? 'brightness(0.9)' : 'none'
          }}
          data-theme={isDarkMode ? 'dark' : 'light'}
        />
      </Box>
    </Box>
  );
};
